// Shared audio instance manager for mobile Chrome compatibility.
// Mobile Chrome requires each HTMLAudioElement to have .play() called
// within a user gesture. We "prime" persistent instances on the Deploy tap,
// then reuse them everywhere.

let introAudio: HTMLAudioElement | null = null;
let outroAudio: HTMLAudioElement | null = null;

/**
 * Call from a direct user-gesture handler (e.g. Deploy button).
 * Creates Audio elements and primes them with a muted play→pause
 * so subsequent .play() calls succeed even from useEffect.
 */
export function primeGameAudio(introUrl: string | null, outroUrl: string | null) {
  if (introUrl) {
    introAudio = new Audio(introUrl);
    introAudio.preload = 'auto';
    introAudio.muted = true;
    introAudio.play().then(() => {
      introAudio!.pause();
      introAudio!.currentTime = 0;
      introAudio!.muted = false;
    }).catch(() => {});
  }

  if (outroUrl) {
    outroAudio = new Audio(outroUrl);
    outroAudio.preload = 'auto';
    outroAudio.muted = true;
    outroAudio.play().then(() => {
      outroAudio!.pause();
      outroAudio!.currentTime = 0;
      outroAudio!.muted = false;
    }).catch(() => {});
  }
}

export function getIntroAudioElement(): HTMLAudioElement | null {
  return introAudio;
}

export function getOutroAudioElement(): HTMLAudioElement | null {
  return outroAudio;
}

export function releaseGameAudio() {
  if (introAudio) { introAudio.pause(); introAudio = null; }
  if (outroAudio) { outroAudio.pause(); outroAudio = null; }
}

// Legacy fallback — still called on Skip/Next buttons as belt-and-suspenders
let unlocked = false;
export function unlockAudio() {
  if (unlocked) return;
  unlocked = true;
  const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  const buffer = ctx.createBuffer(1, 1, 22050);
  const source = ctx.createBufferSource();
  source.buffer = buffer;
  source.connect(ctx.destination);
  source.start(0);
  const a = new Audio();
  a.play().catch(() => {});
  a.pause();
}
